var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRurki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10,10)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.84,57.568C56.017,61.463 52.192,63.953 48.296,63.13C44.401,62.307 41.91,58.482 42.734,54.586C43.557,50.691 47.382,48.201 51.277,49.024C55.173,49.847 57.663,53.672 56.84,57.568Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.098,58.655C44.437,61.617 39.879,61.862 36.917,59.201C33.955,56.54 33.711,51.982 36.372,49.02C39.032,46.059 43.59,45.814 46.552,48.475C49.514,51.135 49.758,55.693 47.098,58.655Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.117,54.733C34.331,55.968 30.262,53.9 29.027,50.115C27.792,46.33 29.86,42.261 33.645,41.026C37.43,39.791 41.5,41.859 42.734,45.644C43.969,49.429 41.902,53.498 38.117,54.733Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3,46.84C28.404,46.017 25.914,42.191 26.737,38.296C27.56,34.401 31.385,31.91 35.281,32.733C39.176,33.556 41.667,37.382 40.843,41.277C40.02,45.172 36.195,47.663 32.3,46.84Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.212,37.097C28.25,34.437 28.006,29.879 30.666,26.917C33.327,23.955 37.885,23.711 40.847,26.371C43.809,29.032 44.053,33.59 41.393,36.552C38.732,39.514 34.174,39.758 31.212,37.097Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.138,28.116C33.903,24.331 35.97,20.262 39.755,19.027C43.541,17.792 47.61,19.859 48.845,23.645C50.08,27.43 48.012,31.499 44.227,32.734C40.442,33.969 36.372,31.901 35.138,28.116Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.028,22.303C43.851,18.407 47.676,15.917 51.571,16.74C55.467,17.563 57.957,21.388 57.134,25.284C56.311,29.179 52.486,31.67 48.59,30.847C44.695,30.023 42.204,26.198 43.028,22.303Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,21.208C55.431,18.246 59.989,18.002 62.95,20.662C65.912,23.323 66.157,27.881 63.496,30.843C60.836,33.805 56.278,34.049 53.316,31.389C50.354,28.728 50.109,24.17 52.77,21.208Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.755,25.137C65.54,23.902 69.609,25.97 70.844,29.755C72.079,33.54 70.011,37.609 66.226,38.844C62.441,40.079 58.372,38.012 57.137,34.227C55.902,30.441 57.969,26.372 61.755,25.137Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.568,33.031C71.463,33.854 73.954,37.679 73.131,41.574C72.308,45.47 68.482,47.96 64.587,47.137C60.692,46.314 58.201,42.489 59.024,38.593C59.847,34.698 63.673,32.207 67.568,33.031Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.659,42.773C71.621,45.433 71.865,49.991 69.205,52.953C66.544,55.915 61.986,56.16 59.024,53.499C56.062,50.839 55.818,46.281 58.478,43.319C61.139,40.357 65.697,40.112 68.659,42.773Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.733,51.754C65.968,55.539 63.901,59.609 60.116,60.844C56.331,62.078 52.261,60.011 51.026,56.226C49.792,52.441 51.859,48.371 55.644,47.136C59.429,45.902 63.499,47.969 64.733,51.754Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "rgb(198,207,213)",
      strokeWidth: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5,40C89.5,18.199 71.801,0.5 50,0.5C28.199,0.5 10.5,18.199 10.5,40C10.5,61.801 28.199,79.5 50,79.5C71.801,79.5 89.5,61.801 89.5,40Z",
    style: {
      fill: "none",
      stroke: "rgb(232,237,240)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeMiterlimit: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRurki);
export default __webpack_public_path__ + "static/media/rurki.7eb09bdc.svg";
export { ForwardRef as ReactComponent };